import { createFileRoute } from '@tanstack/react-router'
import { PartnerRouteGuard } from '../../components/PartnerRouteGuard'
import { CohortPage } from '../../components/PartnerCohorts/redesign/CohortPage'

export const Route = createFileRoute('/partner/c/$id')({
  component: () => {
    const { id } = Route.useParams()

    return (
      <PartnerRouteGuard>
        <CohortPage cohortId={id} />
      </PartnerRouteGuard>
    )
  },
})
